if (!customElements.get('sa-form-collaboration')) {
  class SaFormCollaboration extends HTMLElement {
    constructor() {
      super();
      this.handleSubmit = this.handleSubmit.bind(this);
      this.checkVisibility = this.checkVisibility.bind(this);
      this.updateHiddenInputs = this.updateHiddenInputs.bind(this);
    }

    connectedCallback() {
      // Ensure DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      this.form = this.querySelector('#collaboration-form');
      if (!this.form) {
        console.warn('SA Collaboration Form: Form element not found');
        return;
      }

      this.collabCheckboxes = this.querySelectorAll('input[name="collaboration_type_checkbox"]');
      this.hiddenCollabInput = this.querySelector('#hidden_collaboration_type');
      this.productFieldsContainer = this.querySelector('#product-fields-container');
      this.hiddenProductInput = this.querySelector('#hidden_plaud_products');
      
      if (!this.productFieldsContainer) {
         console.warn('SA Collaboration Form: Product fields container not found');
      }

      this.initEventListeners();
      this.checkVisibility();
      this.updateHiddenInputs();
      
      console.log('SA Collaboration Form initialized');
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this.handleSubmit);
      }
      
      if (this.collabCheckboxes) {
        this.collabCheckboxes.forEach(cb => cb.removeEventListener('change', this.checkVisibility));
      }
    }

    initEventListeners() {
      // Visibility
      this.collabCheckboxes.forEach(cb => {
        cb.addEventListener('change', this.checkVisibility);
        cb.addEventListener('change', this.updateHiddenInputs);
      });
      
      // Add validation listeners to clear custom validity on change
      this.collabCheckboxes.forEach(cb => {
        cb.addEventListener('change', () => {
             // Clear validity for all in group when any is changed
             this.collabCheckboxes.forEach(box => box.setCustomValidity(''));
        });
      });
      
      if (this.productFieldsContainer) {
          const productCheckboxes = this.productFieldsContainer.querySelectorAll('input[name="plaud_products_checkbox"]');
          productCheckboxes.forEach(cb => {
             cb.addEventListener('change', () => {
                  productCheckboxes.forEach(box => box.setCustomValidity(''));
                  this.updateHiddenInputs();
             });
          });
      }

      // Form Submit
      // We rely on standard submit event which triggers browser validation.
      // But for checkbox groups, we need to inject our validation check BEFORE the browser validation runs?
      // Actually, 'submit' event fires AFTER browser validation if the button is type="submit".
      // If we want to trigger browser validation bubble, we need to set setCustomValidity on 'change' or before submit attempt.
      // A common trick is to check on the submit button click.
      
      const submitBtn = this.form.querySelector('.form-submit');
      if (submitBtn) {
          submitBtn.addEventListener('click', this.validateCheckboxes.bind(this));
      }
      
      this.form.addEventListener('submit', this.handleSubmit);
    }

    updateHiddenInputs() {
        if (this.collabCheckboxes && this.hiddenCollabInput) {
            const selected = Array.from(this.collabCheckboxes)
                .filter(cb => cb.checked)
                .map(cb => cb.value)
                .join(', ');
            this.hiddenCollabInput.value = selected;
        }
        
        if (this.productFieldsContainer && this.hiddenProductInput) {
             const productCheckboxes = this.productFieldsContainer.querySelectorAll('input[name="plaud_products_checkbox"]');
             const selected = Array.from(productCheckboxes)
                .filter(cb => cb.checked)
                .map(cb => cb.value)
                .join(', ');
             this.hiddenProductInput.value = selected;
        }
    }

    checkVisibility() {
        if (!this.productFieldsContainer) return;
        let show = false;
        if (this.collabCheckboxes) {
            this.collabCheckboxes.forEach(cb => {
              // Logic: Appears if either A (Co-branded...) or C (Corporate...) is chosen
              if (cb.checked) {
                const val = cb.value.trim();
                if (val === 'Co-branded limited editions' || val === 'Corporate and premium gifting') {
                  show = true;
                }
              }
            });
        }
    
        // Get all inputs/selects inside the container
        const inputs = this.productFieldsContainer.querySelectorAll('input, select');

        if (show) {
          this.productFieldsContainer.style.display = 'block';
          // Enable inputs so they are validated and submitted
          inputs.forEach(input => input.disabled = false);
        } else {
          this.productFieldsContainer.style.display = 'none';
          // Disable inputs so they are NOT validated (required ignored) and NOT submitted
          inputs.forEach(input => input.disabled = true);
        }
    }

    validateCheckboxes(e) {
        // This function sets CustomValidity on checkboxes so the browser shows the bubble
        // 1. Collab Type
        let collabChecked = false;
        if (this.collabCheckboxes) {
            this.collabCheckboxes.forEach(cb => { if(cb.checked) collabChecked = true; });
        }
        
        if (!collabChecked && this.collabCheckboxes.length > 0) {
           const firstBox = this.collabCheckboxes[0];
           const container = firstBox.closest('.checkbox-group-vertical');
           const msg = container ? container.getAttribute('data-msg-required') : 'Please select at least one collaboration type.';
           firstBox.setCustomValidity(msg);
           // We don't call reportValidity() here immediately because the click will trigger form submission,
           // which will trigger the browser's validation UI automatically if validity is set.
        }

        // 2. Product Type (if visible)
        if (this.productFieldsContainer && this.productFieldsContainer.style.display !== 'none') {
             const productCheckboxes = this.productFieldsContainer.querySelectorAll('input[name="plaud_products_checkbox"]');
             if (productCheckboxes.length > 0) {
                 let prodChecked = false;
                 productCheckboxes.forEach(cb => { if(cb.checked) prodChecked = true; });
                 
                 if (!prodChecked) {
                     const firstBox = productCheckboxes[0];
                     const container = firstBox.closest('.checkbox-group-vertical');
                     const msg = container ? container.getAttribute('data-msg-required') : 'Please select at least one Plaud product.';
                     firstBox.setCustomValidity(msg);
                 }
             }
        }
    }



    handleSubmit(e) {
        // console.log('SA Collaboration Form: handleSubmit called via ' + e.type);

        // At this point, browser validation has passed (because submit event fires after validation).
        // So we just handle the UI state.
        
        const submitBtn = this.form.querySelector('.form-submit');
        if (submitBtn) {
             submitBtn.textContent = 'Sending...';
             if (submitBtn.dataset.submitting === "true") {
                e.preventDefault();
                return;
              }
              submitBtn.dataset.submitting = "true";
        }
        
        // Allow the form to submit naturally to Shopify
    }
  }
  
  customElements.define('sa-form-collaboration', SaFormCollaboration);
}
